<template>
  <div class="mobile">
    <div class="header" id="header">
      <div class="logo">
        <a href="#">
          <img src="../assets/image/logo.png" alt />
          <i>按个摩</i>
        </a>
      </div>
      <span @click="bindShowMenus(true)"></span>
    </div>
    <div class="mobile_info">
      <div class="banner" id="aiming0">
        <h1>按个摩 - 高品质上门按摩平台</h1>
        <p>按个摩是中国领先的O2O上门服务平台，汇聚近千种高品质按摩服务。一键直约，安心到家。</p>
        <div class="btns">
          <a
            href="https://apps.apple.com/cn/app/%E6%8C%89%E4%B8%AA%E6%91%A9-%E5%90%8C%E5%9F%8E%E4%B8%8A%E9%97%A8%E6%8C%89%E6%91%A9%E9%A2%84%E7%BA%A6%E5%B9%B3%E5%8F%B0/id1480920852"
          ></a>
          <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.twototwo.massage"></a>
        </div>
      </div>
      <div class="phone"></div>
      <div class="box">
        <h1 id="aiming1">轻松享受品质生活</h1>
        <h6>
          <i></i>
          <b>ENGOY QUALITY LIFE EASILY</b>
          <i></i>
        </h6>
        <div class="list b1">
          <div class="item">
            <img src="../assets/image/h5/icon_box_1_1.png" alt />
            <h5>一键到家</h5>
            <p>手机预约技师上门服务，足不出户体验美好生活。</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_1_2.png" alt />
            <h5>优选服务</h5>
            <p>平台把关严格筛选高价值、高标准的品牌服务。</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_1_3.png" alt />
            <h5>专业技师</h5>
            <p>平台认证技师手艺精湛，让你每一分钟都是享受。</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_1_4.png" alt />
            <h5>安全无忧</h5>
            <p>完整的线上交易流程加平台监管保障交易安全。</p>
          </div>
        </div>
        <h1 id="aiming2">一键直约安心到家</h1>
        <h6>
          <i></i>
          <b>ONE CLICK STRAIGHT HOME</b>
          <i></i>
        </h6>
        <div class="list b2">
          <div class="item">
            <div>
              <img src="../assets/image/h5/icon_box_2_1.png" alt />
            </div>
            <div class="right">
              <h5>手机预约</h5>
              <p>通过手机下单预约项目和技师</p>
            </div>
            <span>1</span>
          </div>
          <div class="item">
            <div>
              <img src="../assets/image/h5/icon_box_2_2.png" alt />
            </div>
            <div class="right">
              <h5>技师上门</h5>
              <p>技师接单上门服务</p>
            </div>
            <span>2</span>
          </div>
          <div class="item">
            <div>
              <img src="../assets/image/h5/icon_box_2_3.png" alt />
            </div>
            <div class="right">
              <h5>享受按摩</h5>
              <p>在家享受品质服务</p>
            </div>
            <span>3</span>
          </div>
          <div class="item">
            <div>
              <img src="../assets/image/h5/icon_box_2_4.png" alt />
            </div>
            <div class="right">
              <h5>评价服务</h5>
              <p>评价反馈技师服务</p>
            </div>
            <span>4</span>
          </div>
        </div>
        <h1 id="aiming3">全品类按摩服务</h1>
        <h6>
          <i></i>
          <b>ALL KINDS OF MASSAGE SERVICES</b>
          <i></i>
        </h6>
        <div class="list b3">
          <div class="item">
            <img src="../assets/image/h5/icon_box_3_1.png" alt />
            <p>中医理疗</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_3_2.png" alt />
            <p>油压SPA</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_3_3.png" alt />
            <p>美容美体</p>
          </div>
          <div class="item">
            <img src="../assets/image/h5/icon_box_3_4.png" alt />
            <p>养生足疗</p>
          </div>
        </div>
      </div>
      <div class="box comment" id="aiming4">
        <h1>用户喜欢我们的产品</h1>
        <h6>
          <i></i>
          <b>USERS LIKE OUR PRODUCTS</b>
          <i></i>
        </h6>
        <div class="list b4">
          <div class="item">
            <img src="../assets/image/pc/icon_comment_1.png" alt />
            <h5>王小雨</h5>
            <p>第一次体验，预约了一个中医推拿的项目，师傅按手法还不错，整体都比较满意。给个五星支持一下吧。</p>
          </div>
          <div class="item">
            <img src="../assets/image/pc/icon_comment_2.png" alt />
            <h5>李密</h5>
            <p>技师力道把握的很好，这个软件很棒，喜欢你们技师的手法，我要说我很喜欢吧我是朋友。。</p>
          </div>
          <div class="item">
            <img src="../assets/image/pc/icon_comment_3.png" alt />
            <h5>邹艺</h5>
            <p>比了很多家了，比去实体店要划算，非常专业技师把每一个细节都做的非常专业微信还可以下单了很了不起。</p>
          </div>
        </div>
      </div>
      <div class="map flex_center" id="aiming5">
        <img src="../assets/image/pc/icon_map.png" alt />
        <div class="right flex_center">
          <div class="icon">
            <img src="../assets/image/pc/icon_map_i_1.png" alt />
            <img class="line" src="../assets/image/pc/icon_map_line.png" alt />
            <img src="../assets/image/pc/icon_map_i_2.png" alt />
            <img class="line" src="../assets/image/pc/icon_map_line.png" alt />
            <img src="../assets/image/pc/icon_map_i_3.png" alt />
          </div>
          <div class="data">
            <div class="item">
              <i>200+</i>
              <b>城市</b>
            </div>
            <div class="item">
              <i>20000+</i>
              <b>技师</b>
            </div>
            <div class="item">
              <i>2000万+</i>
              <b>用户</b>
            </div>
          </div>
        </div>
      </div>
      <div class="down flex_center" id="aiming6">
        <div class="inner">
          <h1>立即下载体验</h1>
          <div class="btns">
            <a
              href="https://apps.apple.com/cn/app/%E6%8C%89%E4%B8%AA%E6%91%A9-%E5%90%8C%E5%9F%8E%E4%B8%8A%E9%97%A8%E6%8C%89%E6%91%A9%E9%A2%84%E7%BA%A6%E5%B9%B3%E5%8F%B0/id1480920852"
            ></a>
            <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.twototwo.massage"></a>
          </div>
          <div class="codes">
            <div class="code">
              <img src="../assets/image/pc/icon_miniApp_code.jpg" alt />
              <!-- <p>按个摩小程序</p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="footer" id="aiming7">
        <div class="contact_and_about_us">
          <div class="inner">
            <div class="contact">
              <h3>联系我们</h3>
              <p>客服：400-862-0602</p>
              <p>邮箱：wzh@angemo.com</p>
              <div class="store">
                <label>商家入驻</label>
                <label>400-862-0602</label>
              </div>
            </div>
            <div class="follow">
              <h3>关注我们</h3>
              <div class="code">
                <img src="../assets/image/pc/icon_open_code.jpg" alt />
              </div>
            </div>
            <div class="about">
              <h3>关于我们</h3>
              <p>按个摩是一个高品质按摩平台，为商户提供获客渠道为用户提供按摩服务。支持到店按摩和上门按摩，连接本地优质商户，连接本地优质技师，以用户为中心，按个摩始终致力于用户提供高品质的按摩服务体验。</p>
            </div>
          </div>
        </div>
        <div class="keep_on_record">
          <a href="https://beian.miit.gov.cn">
            深圳凸凸网络科技有限公司
            <br />©angemo.com {{beian}}
          </a>
        </div>
      </div>
    </div>
    <div :class="showMenus?'mask show':'mask'">
      <div :class="animation?'menus show_menus':'menus hide_menus'">
        <div class="top">
          <div class="logo">
            <a href="#">
              <img src="../assets/image/logo.png" alt />
              <i>按个摩</i>
            </a>
          </div>
          <span @click="bindShowMenus(false)"></span>
        </div>
        <div class="item" @click="bindMenuEvent(0)">首页</div>
        <div class="item" @click="bindMenuEvent(1)">平台优势</div>
        <div class="item" @click="bindMenuEvent(2)">使用方式</div>
        <div class="item" @click="bindMenuEvent(3)">服务品类</div>
        <div class="item" @click="bindMenuEvent(4)">用户评价</div>
        <div class="item" @click="bindMenuEvent(5)">用户分布</div>
        <div class="item" @click="bindMenuEvent(6)">下载APP</div>
        <div class="item" @click="bindMenuEvent(7)">联系我们</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mobile",
  props: {},
  data() {
    return {
      showMenus: false,
      animation: false,
      top: 0,
      scrollTop: 0,
      beian: "粤ICP备16027090号-1",
    };
  },
  mounted() {
    if (location.host.indexOf("angemo.com") >= 0) {
      this.beian = "粤ICP备16027090号-1";
    } else if (location.host.indexOf("angemo.net") >= 0) {
      this.beian = "粤ICP备16027090号-2";
    } else if (location.host.indexOf("angemo.cn") >= 0) {
      this.beian = "粤ICP备16027090号-3";
    } else if (location.host.indexOf("twototwo.net") >= 0) {
      this.beian = "粤ICP备16027090号-5";
    } else if (location.host.indexOf("twototwo.cn") >= 0) {
      this.beian = "粤ICP备16027090号-6";
    }
  },
  methods: {
    bindShowMenus(e) {
      this.animation = e;
      if (e) {
        this.showMenus = e;

        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";

        // document.body.addEventListener(
        //   "touchmove",
        //   function(e) {
        //     e.preventDefault();
        //   },
        //   { passive: false }
        // );
      } else {
        setTimeout(() => {
          this.showMenus = e;
          document.documentElement.style.overflow = "auto";
          document.body.style.overflow = "auto";
          // document.body.removeEventListener(
          //   "touchmove",
          //   function(e) {
          //     e.returnValue = true;
          //   },
          //   { passive: false }
          // );
        }, 400);
      }
    },
    bindMenuEvent(i) {
      this.showMenus = false;
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
      var header = this.$el.querySelector(`#header`);
      var anchor = this.$el.querySelector(`#aiming${i}`);
      this.loadScrollTo(anchor.offsetTop - header.offsetHeight);
    },
    loadScrollTo(to) {
      document.body.scrollTop = to;
      document.documentElement.scrollTop = to;
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.mobile {
  position: relative;
  overflow: hidden;
  padding: 0.88rem 0 0;
  width: 100%;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 0.88rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0.02rem 0.06rem 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0.3rem;
    z-index: 9999;

    .logo {
      a {
        display: flex;
        align-items: center;
        color: #000000;
        font-size: 0.3rem;

        img {
          width: 0.64rem;
          height: 0.64rem;
          margin-right: 0.12rem;
        }
      }
    }

    span {
      display: block;
      width: 0.28rem;
      height: 0.28rem;
      background: url("../assets/image/h5/header_menu.png") no-repeat center
        center;
      background-size: 100% 100%;
    }
  }

  .banner {
    width: 100%;
    height: 4rem;
    background: url("../assets/image/h5/banner.png") no-repeat;
    background-size: 100% auto;
    color: #fff;
    box-sizing: border-box;
    padding: 0.48rem 0.3rem;
    text-align: left;
    h1 {
      font-size: 0.42rem;
      font-weight: normal;
    }
    p {
      font-size: 0.24rem;
      margin: 0.2rem 0 0.6rem;
    }
    .btns {
      display: flex;
      a {
        width: 1.8rem;
        height: 0.8rem;
        border-radius: 0.04rem;
        background: url("../assets/image/h5/icon_ios_down.png") no-repeat;
        background-size: 100% auto;
        &:nth-child(2) {
          background: url("../assets/image/h5/icon_android_down.png") no-repeat;
          background-size: 100% auto;
          margin-left: 0.4rem;
        }
      }
    }
  }

  .phone {
    width: 100%;
    height: 7.3rem;
    background: url("../assets/image/h5/icon_phone.png") no-repeat center bottom;
    background-size: 100% auto;
  }

  .box {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -0.06rem 0.06rem 0px rgba(0, 0, 0, 0.03);
    text-align: center;

    h1 {
      font-weight: normal;
      font-size: 0.4rem;
      color: #333;
      padding-top: 0.5rem;
    }

    h6 {
      display: flex;
      align-items: center;
      font-size: 0.14rem;
      color: #999999;
      justify-content: center;
      font-weight: normal;
      padding-bottom: 0.5rem;

      i {
        width: 0.14rem;
        height: 1px;
        background: rgba(216, 216, 216, 1);
      }
      b {
        margin: 0 0.1rem;
      }
    }

    .list {
      padding: 0 0.3rem;
    }

    .b1 {
      .item {
        width: 100%;
        height: 3.6rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.04rem;
        margin-bottom: 0.2rem;
        overflow: hidden;
        img {
          width: 1.6rem;
          display: block;
          margin: 0.2rem auto 0.16rem;
        }
        h5 {
          font-weight: normal;
          color: #333333;
          font-size: 0.34rem;
        }
        p {
          margin: 0.18rem auto 0;
          width: 5.33rem;
          color: #999999;
          font-size: 0.28rem;
        }
      }
    }

    .b2 {
      .item {
        width: 100%;
        height: 2.02rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.04rem;
        margin-bottom: 0.1rem;
        box-sizing: border-box;
        padding-left: 0.8rem;
        display: flex;
        align-items: center;
        position: relative;

        img {
          display: block;
          width: 1.5rem;
          margin-right: 0.2rem;
        }

        .right {
          text-align: left;
          h5 {
            color: #333333;
            font-size: 0.34rem;
            font-weight: normal;
          }
          p {
            color: #999;
            margin-top: 0.1rem;
            font-size: 0.28rem;
          }
        }

        span {
          display: block;
          width: 0.4rem;
          height: 0.4rem;
          background: rgba(221, 221, 221, 1);
          line-height: 0.4rem;
          text-align: center;
          position: absolute;
          left: 0.2rem;
          top: 0.2rem;
          color: #fff;
          font-size: 0.26rem;
          border-radius: 50%;
        }
      }
    }

    .b3 {
      .item {
        img {
          width: 100%;
          display: block;
        }
        p {
          text-align: center;
          color: #333333;
          font-size: 0.34rem;
          padding: 0.16rem 0 0.34rem;
        }
      }
    }
  }
  .comment {
    margin-top: 0.48rem;
    height: 16.51rem;
    box-shadow: 0px 0px 0.2rem 0px rgba(0, 0, 0, 0.08);
    background: url("../assets/image/h5/icon_comment_back.png") no-repeat;
    background-size: 100% auto;
    color: #fff;
    h1 {
      color: #fff;
    }
    h6 {
      b {
        color: #fff;
      }
    }

    .list {
      padding-top: 1rem;
      .item {
        width: 100%;
        height: 3.4rem;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 0.2rem 0px rgba(0, 0, 0, 0.08),
          0px 0px 0.1rem 0px rgba(0, 0, 0, 0.14);
        border-radius: 0.1rem;
        position: relative;
        box-sizing: border-box;
        padding: 1.16rem 0.47rem 0;
        margin-bottom: 1.3rem;

        img {
          position: absolute;
          width: 2rem;
          left: 50%;
          transform: translateX(-50%);
          top: -1rem;
        }

        h5 {
          text-align: center;
          color: #333;
          font-size: 0.34rem;
          font-weight: normal;
        }
        p {
          color: #999;
          font-size: 0.28rem;
          margin-top: 0.2rem;
        }
      }
    }
  }

  .map {
    height: 5.53rem;
    > img {
      width: 4.79rem;
      margin-right: 0.5rem;
    }

    .right {
      .icon {
        margin-right: 0.23rem;

        img {
          display: block;
          margin: auto;
          width: 0.27rem;
        }

        .line {
          width: 0.09rem;
          margin: 0.1rem auto;
        }
      }
      .data {
        .item {
          margin-bottom: 0.58rem;

          &:last-child {
            margin: 0;
          }
          i,
          b {
            display: block;
          }
          i {
            color: #333333;
            font-size: 0.3rem;
            margin-bottom: 0.1rem;
          }

          b {
            font-size: 0.24rem;
            color: #999999;
          }
        }
      }
    }
  }

  .down {
    box-shadow: 0px 0px 0.2rem 0px rgba(0, 0, 0, 0.04);
    .inner {
      height: 5.6rem;
      text-align: center;
      color: #333333;
      h1 {
        font-size: 0.4rem;
        padding: 0.5rem 0 0.3rem;
        font-weight: normal;
      }
      .btns {
        a {
          display: block;
          margin: auto;
          width: 1.8rem;
          height: 0.8rem;
          border-radius: 0.04rem;
          background: url("../assets/image/h5/icon_ios_down.png") no-repeat;
          background-size: 100% auto;
          margin-bottom: 0.3rem;

          &:nth-child(2) {
            background: url("../assets/image/h5/icon_android_down.png")
              no-repeat;
            background-size: 100% auto;
          }
        }
      }
      .codes {
        .code {
          img {
            width: 1.6rem;
            margin-bottom: 0.44rem;
          }
          p {
            font-size: 0.2rem;
          }
        }
      }
    }
  }

  .footer {
    height: 9.09rem;
    position: relative;

    .contact_and_about_us {
      width: 100%;
      height: 8.09rem;
      background: #666666;
      box-shadow: 0px 0px 0.2rem 0px rgba(0, 0, 0, 0.04);
      color: #fff;
      box-sizing: border-box;
      .inner {
        width: 100%;
        overflow: hidden;
        padding: 0 0.3rem;
        box-sizing: border-box;

        h3 {
          font-size: 0.3rem;
          font-weight: normal;
          margin: 0.5rem 0 0.1rem;
        }

        p {
          font-size: 0.26rem;
        }

        > div {
          text-align: left;
        }
        .contact {
          .store {
            margin-top: 0.1rem;
            width: 2.1rem;
            height: 1rem;
            background: rgba(255, 255, 255, 1);
            border-radius: 0.04rem;
            color: #333333;
            font-size: 0.24rem;
            box-sizing: border-box;
            padding-left: 0.2rem;
            padding-top: 0.1rem;
            label {
              display: block;
              margin-bottom: 0.15rem;
            }
          }
        }

        .follow {
          .code {
            width: 1.4rem;
            height: 1.4rem;
            border-radius: 0.04rem;
            overflow: hidden;
            img {
              width: 1.4rem;
              height: 1.4rem;
            }
          }
        }
      }
    }
    .keep_on_record {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1rem;
      width: 100%;
      background: #333333;
      border-radius: 1px;
      text-align: center;
      font-size: 0.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        margin: auto;
        color: #e8eff7;
      }
    }
  }

  .mask {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(51, 51, 51, 0.3);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;

    .menus {
      position: absolute;
      right: 0;
      top: 0;
      background: #fff;
      width: 5.2rem;
      height: 100vh;

      .top {
        width: 100%;
        height: 0.88rem;
        background: rgba(255, 255, 255, 1);
        border-bottom: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.3rem;
        z-index: 9999;

        .logo {
          a {
            display: flex;
            align-items: center;
            color: #000000;
            font-size: 0.3rem;

            img {
              width: 0.64rem;
              height: 0.64rem;
              margin-right: 0.12rem;
            }
          }
        }

        span {
          display: block;
          width: 0.3rem;
          height: 0.3rem;
          background: url("../assets/image/h5/icon_menu_close.png") no-repeat;
          background-size: 100% auto;
        }
      }
      .item {
        height: 1.2rem;
        line-height: 1.2rem;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        color: #333333;
        font-size: 0.34rem;

        &:last-child {
          border-bottom: none;
        }
      }
    }
    .show_menus {
      animation: show 0.5s linear;
    }

    .hide_menus {
      animation: hide 0.5s linear;
    }
  }

  .show {
    z-index: 10000;
    opacity: 1;
  }
}
@keyframes show {
  0% {
    right: -100%;
  }
  100% {
    right: 0;
  }
}
@keyframes hide {
  0% {
    right: 0;
  }
  100% {
    right: -100%;
  }
}
</style>